import instance from "@/services/api";

export const projectAgreementCancellationsAPI = {
  async read(params) {
    return await instance()
      .get("/project_list/project/agreement_cancel/read/", { params })
      .then((res) => res?.data);
  },
  async readSbsProjects() {
    return await instance()
      .get("/project_list/project/agreement_cancel/sbs_projects/")
      .then((res) => res?.data);
  },
  async readUspStornoWorks(body) {
    return await instance()
      .post("/project_list/project/agreement_cancel/usp_storno/works/", body)
      .then((res) => res?.data);
  },
  async buildUspStorno(body) {
    return await instance()
      .post("/project_list/project/agreement_cancel/usp_storno/build/", body)
      .then((res) => res?.data);
  },
  async sendUspStorno(body) {
    return await instance()
      .post("/project_list/project/agreement_cancel/usp_storno/send/", body)
      .then((res) => res?.data);
  },
};
